import { render, staticRenderFns } from "./FeatureBox.vue?vue&type=template&id=369a2396&scoped=true"
import script from "./FeatureBox.vue?vue&type=script&lang=ts"
export * from "./FeatureBox.vue?vue&type=script&lang=ts"
import style0 from "./FeatureBox.vue?vue&type=style&index=0&id=369a2396&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369a2396",
  null
  
)

export default component.exports